class GravityFormsScroll {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        // 페이지가 로드될 때 스크롤 처리
        document.addEventListener('DOMContentLoaded', this.scrollToConfirmation.bind(this));
    }

    scrollToConfirmation() {
        const confirmationWrapper = document.querySelector('.gform_confirmation_wrapper');
        if (confirmationWrapper) {
            this.smoothScroll(confirmationWrapper);
            confirmationWrapper.focus();
        }
    }

    smoothScroll(targetElement) {
        const header = document.querySelector('.wp-header');
        const headerHeight = header ? header.offsetHeight : 0;
        // 부모 요소의 상단 위치를 계산
        const parentElement = targetElement.parentElement;
        const parentPosition = parentElement ? parentElement.getBoundingClientRect().top + window.pageYOffset : 0;

        // 부모 요소의 상단 위치에서 헤더 높이와 추가 여유 공간(200px)을 뺀 값을 스크롤 위치로 설정
        const scrollToPosition = parentPosition - headerHeight - 200;

        window.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
    }
}

// 인스턴스 생성 및 실행
new GravityFormsScroll();

